import { Pipe, PipeTransform, Renderer2, ChangeDetectorRef } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

// tslint:disable-next-line: use-pipe-transform-interface
@Pipe({
    name: 'fnTranslate',
    pure: false
})
export class FnTranslatePipe extends TranslatePipe {
    constructor(private translateService: TranslateService, private changeDetectRef: ChangeDetectorRef) {
        super(translateService, changeDetectRef);
    }

    override transform(value: string, ...args: any[]) {
        return super.transform(value, args);
    }
}
